import CountryUserRole from "./role/CountryUserRole.js";
import User from "./User.js";

/**
 * Sub class of `User` to represent the persons who manage a
 * `Country`. These users can create agencies in their attached
 * country and do whatever an agency user can do for these agencies.
 */
export default class CountryUser extends User {
	constructor(spec = {}) {
		super(spec);
		this._countryId = spec.countryId;
	}

	getRoles() {
		return [
			new CountryUserRole({
				countryId: this.getCountryId(),
			}),
		];
	}

	isCountryUser() {
		return true;
	}

	hasCompanyRole() {
		return true;
	}

	getCountryId() {
		return this._countryId;
	}

	getCompanyIds() {
		return [];
	}

	canForcePackageSelection() {
		return true;
	}

	canDowngradeCompany() {
		return true;
	}

	canEditLiquidityReport() {
		return true;
	}

	canViewWithdrawnPeriodReports() {
		return true;
	}

	canSeePeriodReportViewers() {
		return !this.isTemporaryUser();
	}

	canGoToCountry() {
		return true;
	}

	_defaultTypeOfUser() {
		return "CountryUser";
	}

	static possibleTypes() {
		return ["CountryUser"];
	}
}
